import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InterfaceCheckPoint } from 'app/models/check-point.model';
import { InterfaceEmployee } from 'app/models/employee.model';
import { InterfaceJob } from 'app/models/job.model';
import { EmployeeService } from 'app/services/employee.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { take } from 'rxjs/operators';
import { DoCheckPointComponent } from '../do-check-point/do-check-point.component';

@Component({
  selector: 'app-activities-auditor',
  templateUrl: './activities-auditor.component.html',
  styleUrls: ['./activities-auditor.component.scss']
})
export class ActivitiesAuditorComponent implements OnInit {

  employees: InterfaceEmployee[] = [];
  jobs: InterfaceJob[] = [];
  supervisors: InterfaceEmployee[] = [];
  selectedEmployee: InterfaceEmployee = {};
  checkPointsDataAuditor: any = {};
  @Input() user: InterfaceEmployee = {};
  selectedJob: InterfaceJob = {};
  checksPointsJob: InterfaceCheckPoint[] = [];
  isSupervisor = false;

  constructor(
    public modal: NgbModal,
    public spinner: NgxSpinnerService,
    protected employeeService: EmployeeService
  ) { }

  async ngOnInit(): Promise<void> {
    this.user = await this.employeeService.getCurrentUser(

    );
    this.getJobs();
  }

  getJobs(): void {
    this.employeeService.getJobsAuditor(this.user.id).pipe(take(1)).subscribe((result: any) => {
      this.jobs = result;
      for (let i = 0; i < this.jobs.length; i++) {
        this.getSupervisorOfJob(this.jobs[i].supervisorId);
      }
    }, (error: any) => {
      console.error(error);
    });
  }

  getSupervisorOfJob(userId: string): void {
    this.employeeService.getEmployeeInformation(userId).pipe(take(1)).subscribe((result: any) => {
      const findSupervisor = this.supervisors.find((obj: any) => obj.id === userId);
      if (findSupervisor !== undefined) {
        return;
      } else {
        this.supervisors.push(result);
      }
    }, (error: any) => {
      console.error(error);
    });
  }

  selectSupervisor(employee: InterfaceEmployee): void {
    this.isSupervisor = true;
    this.selectedJob = {};
    this.selectedEmployee = employee;
    this.employeeService.getJob(this.selectedEmployee.jobId).pipe(take(1)).subscribe((result: any) => {
      this.selectedJob = result;
      this.getCheckPointsOfJob();
    }, (error: any) => {
      console.error(error);
    });
  }

  // save the employee global and get all the checkpoints of the job
  selectEmployee(employee: InterfaceEmployee): void {
    this.isSupervisor = false;
    this.selectedEmployee = employee;
    this.getCheckPointsOfJob();
  }

  // get the check points of the current job and employee
  getCheckPointsOfJob(): void {
    this.spinner.show(undefined,
      {
        type: 'square-jelly-box',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.employeeService.getCheckPoints(this.selectedJob.id).pipe(take(1)).subscribe((checkPointsResult: InterfaceCheckPoint[]) => {
      this.checksPointsJob = checkPointsResult;
      for (let j = 0; j < this.checksPointsJob.length; j++) {
        this.getCheckPointsDataAuditor(this.checksPointsJob[j]);
      }
      this.spinner.hide();
    }, (error: any) => {
      console.error(error);
      this.spinner.hide();
    });
  }

  // get the data of the check points mesurement of the supervisor with the current job and current employee selected
  getCheckPointsDataAuditor(checkPoint: InterfaceCheckPoint): void {
    this.employeeService.getCheckPointsAuditor(checkPoint, this.user.id, this.selectedEmployee.id).pipe(take(1)).subscribe((checkPointDataResult: any) => {
      if (checkPointDataResult && checkPointDataResult.length > 0) {
        this.checkPointsDataAuditor[checkPoint.id] = true;
      } else {
        this.checkPointsDataAuditor[checkPoint.id] = false;
      }
    }, (error: any) => {
      console.error(error);
    });
  }

  doCheckPoint(checkPoint: InterfaceCheckPoint): void {
    const modalRef = this.modal.open(DoCheckPointComponent, {
      backdrop: "static",
      animation: true,
      centered: true
    });
    modalRef.componentInstance.checkPoint = checkPoint;
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.job = this.selectedJob;
    modalRef.componentInstance.employee = this.selectedEmployee;
    modalRef.componentInstance.role = "Supervisor";
    modalRef.result.then((result) => {
      if (result && result.success) {
        this.checkPointsDataAuditor[checkPoint.id] = true;
      }
    });
  }

  // save global the job and check the users with that jobId
  selectJob(job: InterfaceJob): void {
    this.isSupervisor = false;
    this.selectedJob = job;
    this.selectedEmployee = {};
    this.checkUsersInJob();
  }

  // get all the users with the job id 
  checkUsersInJob(): void {
    this.employeeService.getEmployeesByJob(this.selectedJob.id).pipe(take(1)).subscribe((result: InterfaceEmployee[]) => {
      this.employees = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  downloadFile(url: string): void {
    window.open(url);
  }

}
